export default {
  General: {
    Email: "E-mailadres",
    Send: "Verzenden",
    Done: "Gereed",
    Finish: "Voltooien",
    Try_again: "Opnieuw proberen",
    or: "of"
  },
  SamsungType: {
    bixby: "Met Bixby",
    no_bixby: "Zonder Bixby",
    home_button: "Met de thuisknop"
  },
  sendEmail: {
    repair_tip1: "Dit model kan niet worden hersteld met de mobiele app. Wij sturen u per e-mail de desktopoplossing.",
    check_tip1: "De apparaatcontrole kan niet alleen met de mobiele app worden voltooid. We sturen u de desktopoplossing per e-mail.",
    tip1: "Dit model kan niet worden ontgrendeld met de mobiele app. Wij sturen u per e-mail de desktopoplossing.",
    tip2: "Sluit uw telefoon met een gegevenskabel aan op uw computer om de kans op succes te vergroten.",
    enter_address: "Voer uw e-mailadres in.",
    enter_correct_address: "Gelieve het juiste e-mailadres in te voeren.",
    confidential: "Uw e-mailadres wordt strikt vertrouwelijk gehouden.",
    open_link: "Open {0} op een computerbrowser om Dr.Fone te downloaden.",
    has_sent: "Uw e-mail is verzonden",
    almost: "U bent er bijna",
    step1: "Stap 1",
    open_email: "Open de e-mail op uw computer en download de desktopversie van Dr.Fone via de koppeling die we u hebben gestuurd.",
    step2: "Stap 2",
    repair_launch_tip: "Start Dr.Fone System Repair en log in op uw account om de reparatiefunctie te gebruiken.",
    check_launch_tip: "Installeer de Dr.Fone-desktop en meld je aan met hetzelfde account. Klik op My Device en volg de instructies op het scherm om je apparaat te verbinden. Zodra het apparaat is verbonden, klik je op Device Detail om de gedetailleerde controleresultaten te bekijken.",
    launch_tip: "Start Dr.Fone Ontgrendelen en meld u aan bij uw account om de ontgrendelingsfunctie te gebruiken.",
    contact_us: "Neem contact met ons op voor hulp."
  },
  Unlock: {
    recoveryMode: "Uw apparaat in de herstelmodus zetten",
    wipe_cache: "Wis de cachepartitie op uw apparaat",
    wipe_data: "Volg de instructies om de gegevens van uw apparaat te wissen",
    completed: "Ontgrendelen voltooid",
    completed_tip: "Controleer of de schermvergrendeling is verwijderd op uw apparaat. Als het is mislukt, probeert u het opnieuw.",
    contact_us: "Ontgrendelen mislukt? Neem contact met ons op voor meer hulp."
  },
  UnlockStep: {
    sa1: "1. Schakel de telefoon uit en zorg dat deze is aangesloten op een computer ",
    sa2: "2. Houd de knoppen Volume omhoog + Bixby + Aan/uit tegelijkertijd ingedrukt",
    sa3: "3. Laat de knoppen los zodra het Samsung-logo verschijnt en wacht enkele seconden",
    sa4: "4. Uw apparaat zou nu moeten worden opgestart in de herstelmodus. Kies Opnieuw opstarten met bootloader om de downloadmodus te activeren.",
    sb1: "1. Schakel de telefoon uit en zorg dat deze is aangesloten op een computer",
    sb2: "2. Houd de aan/uit-knop en de knop Volume omhoog tegelijkertijd ingedrukt",
    sb3: "3. Blijf deze twee knoppen ingedrukt houden, zelfs wanneer het apparaat opnieuw wordt opgestart",
    sb4: "4. Uw apparaat zou nu moeten worden opgestart in de herstelmodus. Kies Opnieuw opstarten met bootloader om de downloadmodus te activeren.",
    sc1: "1. Schakel de telefoon uit en zorg dat deze is aangesloten op een computer",
    sc2: "2. Houd de knoppen Volume omhoog + Thuis + Aan/uit tegelijkertijd ingedrukt",
    sc3: "3. Laat de knoppen los zodra het Samsung-logo verschijnt en wacht enkele seconden",
    sc4: "4. Uw apparaat zou nu moeten worden opgestart in de herstelmodus. Kies Opnieuw opstarten met bootloader om de downloadmodus te activeren.",
    s5: "5. Druk op de volumeknop en selecteer Gegevens wissen/fabrieksinstellingen herstellen. Druk vervolgens op de aan/uit-knop om uw keuze te bevestigen",
    s6: "6. Druk op de volumeknop en selecteer Ja. Druk vervolgens op de aan/uit-knop om uw keuze te bevestigen",
    s7: "7. Druk op Cachepartitie wissen en selecteer vervolgens Ja",
    s8: "8. Selecteer Systeem nu opnieuw opstarten en druk op de aan/uit-knop om uw keuze te bevestigen. Het duurt even voordat het apparaat opnieuw is opgestart.",
    common1: "Schakel uw telefoon uit.",
    common2: "Houd de aan/uit-knop en de knop Volume omhoog enkele seconden ingedrukt.",
    common3: "Laat alle knoppen los wanneer de herstelmodus op het scherm wordt weergegeven.",
    m4: "Kies Gegevens wissen met de volumetoetsen en de aan/uit-knop om deze optie te accepteren.",
    m5: "Kies Alle gegevens wissen.",
    m6: "Kies Bevestigen en wacht tot het proces is voltooid.",
    m7: "Ga met de aan-uitknop terug naar het hoofdmenu.",
    m8: "Selecteer Opnieuw opstarten.",
    m9: "Kies tot slot Opnieuw opstarten naar systeem.",
    h4: "Kies Gegevens wissen met de volumetoetsen en de aan/uit-knop om deze optie te accepteren.",
    h5: "Selecteer Fabrieksinstellingen herstellen.",
    h6: "Typ het woord 'Ja' en selecteer Fabrieksinstellingen herstellen.",
    h7: "Tijdens deze bewerking worden al uw bestanden verwijderd.",
    h8: "Selecteer Terug om terug te keren naar het hoofdmenu.",
    h9: "Kies tot slot Opnieuw opstarten."
  }
};
